import { ICopyMapaConcretagemUseCase } from "../../../presentation/useCases/create/copy_mapa_concretagem_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CopyMapaConcretagemUseCase
 */

export class CopyMapaConcretagemUseCase implements ICopyMapaConcretagemUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async copyMapaConcretagem(
    idMapaConcretagem: number,
    copyNumber: number,
  ): Promise<void> {
    await this.repository.copyMapaConcretagem(
      idMapaConcretagem,
      copyNumber,
    );
  }
}
